import { MeContext } from 'contexts/me'
import { useContext } from 'react'
import { getMembershipStatus } from 'utils'
import Badge, { MembershipBadge } from 'components/Badge'

interface MenuButtonProps {
  label: string | JSX.Element
  icon: JSX.Element
  onClick: () => void
  selected: boolean
  extended?: boolean
  isMobile?: boolean
  isMembership?: boolean
  isNew?: boolean
  subLabel?: string
}

const MenuButton = ({
  label,
  icon,
  onClick,
  selected,
  subLabel = null,
  extended = true,
  isMobile = false,
  isMembership = false,
  isNew = false
}: MenuButtonProps) => {
  const { me } = useContext(MeContext)

  return (
    <button
      type='button'
      className={`relative h-10 py-3 flex justify-start rounded-lg flex-row w-full text-left text-black leading-5 ${
        selected
          ? 'bg-green-100 !text-[#08724C] md:hover:bg-green-100'
          : 'md:hover:bg-green-50'
      } ${isMobile ? 'pl-4' : 'pl-6'} items-center h-12 font-bold`}
      onClick={onClick}
    >
      <span className='flex shrink-0 w-6'>{icon}</span>

      {isNew ? (
        <Badge
          className={`absolute text-center duration-150 transition-all -bottom-2 !py-0 !px-2 ${
            extended ? 'h-6 top-3 right-3' : 'h-[18px] w-16 right-[2px]'
          }`}
        >
          <span className='w-full'>Nuevo</span>
        </Badge>
      ) : null}
      {isMembership ? (
        <MembershipBadge
          status={getMembershipStatus(me?.subscriber_products)}
          className={`absolute !text-center duration-100 !transition-all -bottom-2 !py-0 ${
            extended
              ? 'h-6 top-3 !text-2xs right-3 !px-2'
              : 'h-[18px] !text-[10px] w-16 right-[3px] !px-1'
          }`}
        />
      ) : null}
      <div
        className={`transition-all pl-3 ${
          extended ? 'opacity-100' : 'opacity-0'
        } ${isMobile ? 'w-auto' : 'w-48'}`}
      >
        <p className='text-base'>{label}</p>
        {subLabel ? <p className='text-2xs font-medium'>{subLabel}</p> : null}
      </div>
    </button>
  )
}

export default MenuButton
